import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Col, Row } from 'antd'

import Alert from '../../../../common/components/feedback/Alert'
import Button from '../../../../common/components/general/Button'
import Icon from '../../../../common/components/general/Icon'
import { ROUTE_PATHS } from '../../../../common/routePaths'

const CompleteAdministratorProfile = () => {
  const history = useHistory()
  const { t: translate } = useTranslation()

  return (
    <Alert
      type="warning"
      className="mb-24"
      showIcon
      icon={<Icon className="fas fa-exclamation-triangle" />}
      message={
        <Row className="ml-8 mt-16">
          <Col span={18}>
            <h6 className="mb-0">{translate('admin-dashboard.benefit-details.qsehra-manage-people-alert.header')}</h6>
          </Col>
          <Col span={18}>
            <p>
              Complete your administrator profile. You’re required to complete your admin profile before you can sign
              your legal documents and schedule your employee notifications.
            </p>
          </Col>
        </Row>
      }
      action={
        <Button type="primary" onClick={() => history.push(`${ROUTE_PATHS.MANAGE_PEOPLE}/complete-admin-profile`)}>
          {translate('admin-dashboard.benefit-details.qsehra-manage-people-alert.button')}
        </Button>
      }
    />
  )
}

export default CompleteAdministratorProfile
